// extracted by mini-css-extract-plugin
export default {"wrap":"bF-z","fullWidth":"cF-z","hideOnDesktop":"dF-z","content":"eF-z","hasOpenedNav":"fF-z","crumbsList":"gF-z","dropdownsWrap":"hF-z"};